<div class="results-buttons">
  <div class="no-result-ind" *ngIf="filterSourceView?.resourcesCount === 0">{{ actionsContent.noResultsInd }}</div>
  <u-icon
    *ngIf="filterSourceView?.linkState?.isPrivate"
    class="warning-icon"
    [model]="{ type: 'font', value: 'icon-exclamation-mark-circle' }"
    [styles]="{ color: 'var(--yellow-600)', fontSize: '16px' }"
    [pTooltip]="actionsContent.privateLink"
    tooltipPosition="left"
    tooltipStyleClass="u-tooltip"
  >
  </u-icon>

  @if (!disableTiering) {
    <u-button
      *ngIf="(!viewOnly || filterSource.tier === assistantFilterPriority.HIGH) && (index !== 0 || filterSource?.filters?.app)"
      [disabled]="
        viewOnly ||
        !filterSource?.filters?.app ||
        filtersDataSourcesCount <= 1 ||
        ['deleted', 'creatorNoAccess'].includes(filterSourceView.unavailableState)
      "
      (onClick)="priorityChange()"
      class="line-icon toggle-icon-button green"
      [active]="filterSource.tier === assistantFilterPriority.HIGH"
      type="secondary"
      elementSize="small"
      fontIcon="double-arrow"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
      [pTooltip]="priorityTooltip"
      [iconStyles]="{ fontSize: '16px' }"
    ></u-button>
  }

  <u-button
    *ngIf="!viewOnly && (index !== 0 || filterSource?.filters?.app)"
    class="line-icon icon-button-clean"
    data-cy="remove-app"
    elementSize="small"
    fontIcon="times"
    type="secondary"
    [iconStyles]="{ fontSize: '20px' }"
    (onClick)="removeLine()"
    [pTooltip]="actionsContent.remove"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  ></u-button>
</div>
